<template>
    <div class="page-container">
        <CustomModal :visible="visible" @onClose="onClose" />
        <div class="page-wrapper" :style="{ height:'560px', backgroundImage:`url(${bgImg})` }">
            <div class="page-content">
                <div class="text-container">
                    <div class="text">成功案例</div>
                    <div class="sub-text" style="margin:36px 0;">200+项目交付经验，助力企业数字化升级转型 实现降本增效</div>
                    <el-button size="large" class="custom-btn-blue" @click="visible=true">申请体验</el-button>
                </div>
            </div>
        </div>
        <div class="page-wrapper" style="height:auto; background:#F5F7FA;">
            <div class="page-content" style="padding:50px 0;">
                <div class="custom-radio">
                    <div 
                        v-for="item in menuData"
                        :key="item.key"
                        :class="{ 'custom-radio-item':true, 'selected':item.key === menuKey  }"
                        @click="menuKey = item.key"
                    >
                        {{  item.label }}
                    </div>
                </div>
                <!-- 应用列表 -->
                <div class="card-container" style="margin-top:60px; margin-bottom:46px;">               
                    <div 
                        v-if="list.length"
                        v-for="item in list"
                        :key="item.title"
                        class="card"
                        style="width:calc( 33.3% - 16px );"
                    >
                        <div class="card-image" :style="{ backgroundImage:`url(${ getFullPathMethod(item.coverImagePath)})` }"></div>
                        <div class="card-content">
                            <div class="card-title">{{ item.tittle }}</div>
                            <el-tooltip effect="light" :width="460" :content="item.content">
                                <div class="card-desc" style="height:50px; -webkit-line-clamp:2;">{{ item.content || '还没有填写' }}</div>
                            </el-tooltip>
                            <div style="height:24px; margin:14px 0;">
                                <div
                                    v-for="item in getTagList(item.label)"
                                    :key="item"
                                    class="tag"
                                >
                                    {{ item }}
                                </div>
                            </div>
                        </div>
                    </div> 
                    <div v-else class="empty-wrapper">
                        <img :src="emptyBg" />
                    </div>                      
                </div>
                <!-- 分页符 -->
                <el-pagination
                    v-if="total > 9" 
                    class="custom-pagination"
                    :current-page="pageInfo.currentPage" 
                    :page-size="pageInfo.pageSize"
                    :total="total" 
                    @current-page="handlePage"
                    background 
                    layout="prev,pager,next" 
                />
            </div>
        </div>
    </div>
</template>
<script>
    import { getFullPath, getContentList } from '@/api/global.js';
    import CustomModal from '@/components/CustomModal.vue';
    import bgImg from '@/assets/case-bg.png';
    import emptyBg from '@/assets/empty.png';
    const menuData = [
        { label:'能源案例', key:'智慧能源' },
        { label:'安防案例', key:'智慧安全' },
        { label:'环境案例', key:'智慧环境'},
        { label:'运维案例', key:'智慧运维' }
    ];
    export default {
        data(){
            return {
                visible:false,
                bgImg,
                emptyBg,
                pageInfo:{ currentPage:1, pageSize:9 },
                total:0,
                list:[],
                menuData,
                menuKey:'智慧能源'
            }
        },
        methods:{
            getFullPathMethod(path){
                return getFullPath(path);
            },
            getTagList(str){
                if ( !str ) return [];
                return str.split(',').slice(0, 3);
            },
            onClose(){
                this.visible = false;
            },
            fetchContentList(){
                getContentList({ page:this.pageInfo.currentPage, pageSize:this.pageInfo.pageSize, contentType:'案例', category:this.menuKey })
                .then(res=>{
                    if ( res.data.code === 200 ) {
                        this.list = res.data.data.filter(i=>i.category === this.menuKey );
                        this.total = res.data.total;
                    }
                })
            },
            handlePage(page){
                this.pageInfo = { ...this.pageInfo, currentPage:1 };
            }
        },
        watch:{
            menuKey(){
                this.pageInfo = { ...this.pageInfo, currentPage:1 };
            },
            pageInfo(){
                this.fetchContentList();
            }
        },
        mounted(){
            if ( this.$route.query.type ) {
                this.menuKey =  this.$route.query.type;       
            } else {
                this.fetchContentList();
            }
        },
        components:{
            CustomModal
        }
    }
    
</script>
<style scoped>
    .custom-radio {
        border-radius:4px;
        background:#fff;
        display:flex;
        align-items:center;
    }
    .custom-radio .custom-radio-item {
        flex:1;
        height:80px;
        line-height:80px;
        text-align:center;
        border-radius:4px;
        color:#99A0AE;
        font-size:16px;
        color:#525866;
        background:transparent;
        /* transition: all 0.5s; */
        cursor: pointer;
        position:relative;
    }
    .custom-radio .custom-radio-item:last-child {
        margin-right:0;
    }
    .custom-radio .custom-radio-item:hover {
        background:#e0e3ee;
    }
    .custom-radio .custom-radio-item.selected {
        background:#335CFF;
        color:#fff;
    }
    .custom-radio .custom-radio-item.selected::after {
        content:'';
        position:absolute;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid #335CFF;
        left:50%;
        top:100%;
        transform:translateX(-50%);
    }
    .card:hover {
        box-shadow:0 0 50px rgba(0,0,0,.05);
        background-image:url(../../assets/card-hover-bg.png);
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size:cover;
    }
    
</style>